<template>
  <div class="container d-flex align-items-center flex-column mt-1">
    <div class="maincontent-bg d-flex flex-column">
      <rule-header :value="ruleHeader"/>
      <rule-game :value="ruleGame"/>
      <rule-game :value="rulePoint"/>
      <rule-game :value="ruleSpecialPoint"/>
    </div>
  </div>
</template>

<script>
import royalFlush from '../../assets/gamerule/6cards/Rank_01.png';
import topA from '../../assets/gamerule/6cards/Score-Cards_0.png';
import textRank from '../../assets/gamerule/6cards/Text_Rank.png';
import textScore from '../../assets/gamerule/6cards/Text_Score_Cards.png';
import straightFlush from '../../assets/gamerule/6cards/straightFlush.png';
import flush from '../../assets/gamerule/6cards/flush.png';
import straight from '../../assets/gamerule/6cards/straight.png';
import threeOfKinds from '../../assets/gamerule/6cards/threeOfKinds.png';
import onePair from '../../assets/gamerule/6cards/onePair.png';
import highCards from '../../assets/gamerule/6cards/Rank_07.png';
import expair from '../../assets/gamerule/6cards/Score-Cards_01.png';
import exthreeOfKinds from '../../assets/gamerule/6cards/ex_threeOfKinds.png';
import exstraightFlush from '../../assets/gamerule/6cards/ex_straightFlush.png';
import exroyalFlush from '../../assets/gamerule/6cards/Score-Cards_04.png';
import boardGame6Cards from '../../assets/gamerule/6cards/Chinese Poker 6 Cards.png';
import ruleGame1 from '../../assets/gamerule/6cards/rule_1.png';
import ruleGame2 from '../../assets/gamerule/6cards/Rules_02.png';
import ruleGame3 from '../../assets/gamerule/6cards/rule_3.png';
import ruleMain from '../../assets/gamerule/6cards/Asset_rule_Web_Text1.png';

export default {
  name: 'rule_6cards',
  data() {
    return {
      ruleHeader: {
        gameName: 'ไพ่สามกอง 6 ใบ (6 Cards Chinese poker)',
        boardImg: boardGame6Cards,
      },
      ruleGame: [
        {
          type: 'imageNoborder',
          image: ruleMain,
          class: 'w-30',
        },
        {
          type: 'yellowSubtext',
          text: 'ไพ่ 3 กอง 6 ใบ มีหลักการจำง่าย ๆ คือ เริ่มเกมส์แจกไพ่ 6 ใบ มีรูปแบบการจัดไพ่ คือ',
          classSub: 'subTextsize',
          textSub: '1-2-3',
        },
        {
          type: 'imageNoborder',
          image: ruleGame1,
          class: 'w-50 center',
        },
        {
          type: 'hightlightText',
          textHead: '1. แถวบน',
          text: 'วางไพ่ได้ 1 ใบ ต้องมีแต้มน้อยที่สุด',
        },
        {
          type: 'hightlightText',
          textHead: '2. แถวกลาง',
          text: 'วางไพ่ได้ 2 ใบ ต้องมีแต้มมากกว่าแถวบนและน้อยกว่าแถวล่าง',
        },
        {
          type: 'hightlightText',
          textHead: '3. แถวล่าง',
          text: 'วางไพ่ได้ 3 ใบ ต้องมีแต้มมากกว่าแถวบนและแถวกลาง',
        },
        {
          type: 'imageNoborder',
          image: ruleGame2,
          class: 'w-35 center',
        },
        {
          type: 'text',
          text: 'โดยแบ่งเป็น แถวบน แถวกลาง และ แถวล่างจัดไพ่จากแถวล่างสุดก่อนเพราะแถวล่างสุดต้องเป็นไพ่ ที่มีแต้มมากที่สุดส่วนมากนิยมเป็น ไพ่สเตรทฟลัช ไพ่สี หรือ ไพ่เรียงต่อมาแถวกลางให้มีแต้มน้อยกว่าแถวล่างสุดแต่ต้องมีแต้มมากกว่าแถวบน เช่นถ้าแถวล่างสุดเป็นไพ่สี แถวกลางต้องเป็นไพ่คู่หรือไพ่สูงส่วนแถวบนนิยมจัด ไพ่สูง',
        },
        {
          type: 'imageNoborder',
          image: ruleGame3,
          class: 'w-75 center',
        },
        {
          type: 'textSubcolor',
          textSub: 'เฉพาะกรณี',
          textSubcolor: 'ไพ่สูง',
          textSub1: 'หรือ',
          textSubcolor1: 'High card',
          textSub2: 'ถ้าตัวคุมตัวแรกเหมือนกัน ให้วัดกันที่ตัวคุม ตัวที่ 2 โดยไม่ต้องวัดกันที่ดอก',
        },
      ],
      rulePoint: [
        {
          type: 'imageNoborder',
          image: textRank,
          class: 'w-15 left',
        },
        {
          type: 'text',
          text: 'เรียงแต้มไพ่ใหญ่ที่สุดลงไปหาแต้มเล็กที่สุด โดยเรียงจาก รอยัลฟลัช > สเตรทฟลัช > ไพ่สี > ไพ่เรียง > ไพ่ตอง > คู่1 > ไพ่สูง ถ้าทะลุ x2 การเทียบแต้มไพ่ ( A > K > Q > J > 10 > 9 > 8 > 7 > 6 > 5 > 4 > 3 > 2 ) หากแต้มไพ่เท่ากันจะมีการเทียบจากดอก ( โพธิ์ดำ > โพธิ์แดง > ดอกจิก > ข้าวหลามตัด ) ถ้าในห้อง มี 3 คน ทะลุทั้งหมด 2 คน x3 , ถ้าในห้อง มี 4 คน ทะลุทั้ง 3 คน x4',
        },
        {
          type: 'hightlightText',
          textHead: '1. รอยัลฟลัช',
          class: 'margintop',
        },
        {
          type: 'imageText',
          image: royalFlush,
          class: 'w-50',
          classMain: 'pad-border',
          text: 'คือ ไพ่ที่เรียงกัน 3 ใบเป็นดอกเดียวกันและต้องสีเดียวกันเป็นไพ่ 10 , J , Q , K , A เท่านั้นรอยัลฟลัช +8',
        },
        {
          type: 'hightlightText',
          textHead: '2. เสตรทฟลัช',
        },
        {
          type: 'imageText',
          image: straightFlush,
          class: 'w-60',
          classMain: 'pad-border',
          text: 'คือ ไพ่ที่เรียงกัน 3 ใบ สีเดียวกัน ดอกเดียวและต้องเรียงกันและไม่ใช่ 10 , J , Q , K , A สเตรทฟลัช +6',
        },
        {
          type: 'hightlightText',
          textHead: '3. ไพ่สี',
        },
        {
          type: 'imageText',
          image: flush,
          class: 'w-60',
          classMain: 'pad-border',
          text: 'คือ ไพ่ที่มีสีหรือดอกเดียวกัน 3 ใบ ไม่จำเป็นต้องมีไพ่เรียงกัน',
        },
        {
          type: 'hightlightText',
          textHead: '4. ไพ่เรียง',
        },
        {
          type: 'imageText',
          image: straight,
          class: 'w-60',
          classMain: 'pad-border',
          text: 'คือ ไพ่ที่มีแต้มเรียงกันดอกใดก็ได้ ( ไม่จำเป็นต้องสีเดียวกัน )',
        },
        {
          type: 'hightlightText',
          textHead: '5. ไพ่ตอง',
        },
        {
          type: 'imageText',
          image: threeOfKinds,
          class: 'w-60',
          classMain: 'pad-border',
          text: 'คือ ไพ่ที่มีแต้มเหมือนกัน 3 ใบ ตอง +4 , ตอง A +8',
        },
        {
          type: 'hightlightText',
          textHead: '6. คู่ 1',
        },
        {
          type: 'imageText',
          image: onePair,
          class: 'w-60',
          classMain: 'pad-border',
          text: 'คือ ไพ่ที่มีแต้มเหมือนกัน 2 ใบ แค่ 1 ชุด 1 คู่ A +2',
        },
        {
          type: 'hightlightText',
          textHead: '7. ไพ่สูง',
        },
        {
          type: 'imageText',
          image: highCards,
          class: 'w-50',
          classMain: 'pad-border',
          text: 'คือ ไพ่ที่ไม่สามารถจับคู่หรือจัดวางเข้ากลุ่มไพ่ได้ ส่วนมากจะจัดวางไว้แถวบนสุด',
        },
      ],
      ruleSpecialPoint: [
        {
          type: 'imageNoborder',
          image: textScore,
          class: 'w-25',
        },
        {
          type: 'hightlightText',
          textHead: '1. ไพ่สูง',
        },
        {
          type: 'image',
          image: topA,
          class: 'w-20',
        },
        {
          type: 'hightlightText',
          class: 'margintop',
          textHead: '2. คู่',
        },
        {
          type: 'image',
          image: expair,
          class: 'w-35',
        },
        {
          type: 'hightlightText',
          class: 'margintop',
          textHead: '3. ไพ่ตอง',
        },
        {
          type: 'image',
          image: exthreeOfKinds,
          class: 'w-40',
        },
        {
          type: 'hightlightText',
          class: 'margintop',
          textHead: '4. ไพ่สเตรทฟลัช',
        },
        {
          type: 'image',
          image: exstraightFlush,
          class: 'w-35',
        },
        {
          type: 'hightlightText',
          class: 'margintop',
          textHead: '5. ไพ่รอยัลฟลัช',
        },
        {
          type: 'image',
          image: exroyalFlush,
          class: 'w-35',
        },
        {
          type: 'hightlightText',
          textHead: 'ยิงปืน',
          class: 'left',
        },
        {
          type: 'text',
          text: 'เมื่อชนะผู้เล่นคนอื่นทั้ง 3 ชุด ได้เพิ่ม x2 ต่อคน',
        },
        {
          type: 'hightlightText',
          textHead: 'โฮมรัน',
          class: 'left',
        },
        {
          type: 'text',
          text: 'คือชนะทุกคน ทุกชุดตั้งแต่ 3 คน ขึ้นไป',
        },
        {
          type: 'text',
          text: 'ชนะ 3 คน ได้เพิ่ม X3',
        },
        {
          type: 'text',
          text: 'ชนะ 4 คน ได้เพิ่ม X4',
        },
      ],
    };
  },
};
</script>

<style lang="css" scoped>
.white-color {
  color: white;
}

.font-big {
  font-size: 1.8vw;
}
</style>
